export default __webpack_public_path__ + "static/media/resubscribe.48073436.svg";